import React from "react";

/**
 * Avantech official logo — uses the real brand asset.
 * - variant "dark"  → orange A + dark gray "avantech" (use on light backgrounds)
 * - variant "light" → all-white version (use on dark backgrounds)
 *
 * Source aspect ratio ≈ 4.08:1 (1537×377).
 */
export const Logo = ({ variant = "dark", className = "", size = 36 }) => {
  const src = variant === "light" ? "/avantech-logo-white.png" : "/avantech-logo-color.png";
  // Height drives sizing; width derives from natural aspect ratio.
  return (
    <img
      src={src}
      alt="Avantech"
      data-testid="avantech-logo"
      className={`block w-auto select-none ${className}`}
      style={{ height: `${size}px` }}
      draggable={false}
    />
  );
};

export default Logo;
